import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { DashboardSidebar } from "./DashboardSidebar";
import { DashboardTopbar } from "./DashboardTopbar";
import { cn } from "../../lib/cn";
import { useAccount } from "../../context/AccountContext";
import { Loader2 } from "lucide-react";

export function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { account, loading } = useAccount();

  if (loading) {
    return <div className="grid min-h-screen place-items-center bg-[#f8fbf8]"><div className="text-center"><Loader2 size={34} className="mx-auto animate-spin text-brand-600" /><p className="mt-3 text-sm font-bold text-slate-500">Memuat workspace...</p></div></div>;
  }
  if (!account?.entitlements.dashboardAccess) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-[#f7f8f3]">
      <DashboardSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((value) => !value)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className={cn("min-h-screen transition-[padding] duration-200", collapsed ? "lg:pl-[88px]" : "lg:pl-[272px]") }>
        <DashboardTopbar onMenu={() => setMobileOpen(true)} />
        <main className="px-5 py-6 sm:px-7 lg:px-9 lg:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
